import { Button, makeStyles, shorthands } from '@fluentui/react-components';
import { Stop24Filled } from '@fluentui/react-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface StopCompletionButtonProps {
    completionInProgress: boolean;
    onStopCompletion: () => void;
}

const useStyle = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        minHeight: '35px',
        ...shorthands.padding('1rem'),
        // Reduce padding significantly on mobile
        '@media (max-width: 768px)': {
            ...shorthands.padding('0.25rem'),
            minHeight: '20px',
        },
    },
});

const StopCompletionButton: FC<StopCompletionButtonProps> = (props) => {
    const { completionInProgress, onStopCompletion } = props;
    const classes = useStyle();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            {
                completionInProgress
                    ? <Button onClick={onStopCompletion} appearance='primary' icon={<Stop24Filled />}>
                        {t('query.stopCompletion')}
                    </Button>
                    : null
            }
        </div>
    );
};

export default StopCompletionButton;
